import { useAudiencesCRUDActions } from '@mm/state/actions/AudiencesCRUDActions';
import { useFetchAudiences } from '@mm/state/hooks/use-fetch-audiences';
import AudiencesModel from '@mm/state/model/AudiencesModel';
import {
  selectAudienceSorted,
  selectAudiencesPagination,
} from '@mm/state/selectors/messengerAdSelectors';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import Select from 'antd/es/select';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styles from './AudienceSimpleSelect.module.css';

export const AudienceSimpleSelect = ({
  onChange,
  selectedAudienceId,
  className,
  withFetch = true,
  options: externalOptions,
  placeholder = 'Choose',
}: {
  onChange: (audienceId: number) => void;
  selectedAudienceId?: number;
  className?: string;
  withFetch?: boolean;
  options?: AudiencesModel[];
  placeholder?: string;
}) => {
  const pagination = useSelector(selectAudiencesPagination);
  const audiences = useSelector(selectAudienceSorted);
  const botId = useSelector(activeChatbotIdSelector);
  const [selectedAudience, setSelectedAudience] = useState<number | undefined>(
    selectedAudienceId,
  );

  const { fetch, fetchMore, isFetching } = useFetchAudiences({
    skipBusy: true,
  });
  const { retrieveAudienceById } = useAudiencesCRUDActions();

  const handleChange = (audienceId: number) => {
    setSelectedAudience(audienceId);
    onChange(Number(audienceId));
  };

  const options = (externalOptions || audiences).map(audience => ({
    value: audience.id,
    label: audience.name,
  }));

  const handleScroll = async e => {
    const { target } = e || {};
    if (
      target &&
      target.scrollTop + target.clientHeight === target.scrollHeight
    ) {
      if (pagination.isLastPage) return;
      await fetchMore();
    }
  };

  const setDefaultValue = async () => {
    if (selectedAudienceId) {
      await retrieveAudienceById(botId, selectedAudienceId, true);
    }
  };

  useEffect(() => {
    setSelectedAudience(selectedAudienceId);
  }, [selectedAudienceId]);

  useEffect(() => {
    if (withFetch) {
      fetch(1, 50);
    }
    setDefaultValue();
  }, []);

  return (
    <Select
      className={className}
      value={selectedAudience}
      placeholder={placeholder}
      loading={isFetching}
      onChange={handleChange}
      options={options}
      onPopupScroll={handleScroll}
      popupClassName={styles.popup}
    />
  );
};
